import React, { useEffect } from "react";
import { Row, Col, Button, Container } from "reactstrap"

const TablePagination = ({ totalCount, pageNumber, pageCount, onPageChange, data, pageSize, isSorting, onPageSizeChange }) => {
    const [inputPageNumber, setInputPageNumber] = React.useState(0);


    useEffect(() => {
        onPageChange(inputPageNumber)
    }, [inputPageNumber])

    const handlenext = () => {
        onPageChange(pageNumber + 1)
        onPageSizeChange(pageSize)
        setInputPageNumber(pageNumber + 1)
    }
    const handleprev = () => {
        onPageChange(pageNumber <= 1 ? 1 : pageNumber - 1);
        onPageSizeChange(pageSize);
        setInputPageNumber(pageNumber <= 1 ? 0 : pageNumber -1)
    }

    const handlelastpage = () => {
        onPageChange(Math.ceil(totalCount / pageSize))
        onPageSizeChange(pageSize)
        setInputPageNumber(Math.ceil(totalCount / pageSize) - 1)
    }

    const handlestartpage = () => {
        onPageChange(1)
        onPageSizeChange(pageSize)
        setInputPageNumber(0)
    }

    const onChangeInInput = event => {
    if (pageCount>= event.target.value) {
        const page = event.target.value > 0 ? Number(event.target.value) - 1 : 0
        setInputPageNumber(page);
      }
    }

    const onChangeInSelect = event => {
        onPageSizeChange(Number(event.target.value))
        onPageChange(Number(event.target.value) === 0 ? 0 : pageNumber)
        setInputPageNumber(Number(event.target.value) === 0 ? 0 : inputPageNumber)
    }

    return (
        <div className="pagination justify-content-end customiz_pagination">
            {(data || []).length > 0 && (
                <Col sm={2} className="me-3 p-2">
                    <select
                        className="form-select p-2"
                        value={pageSize}
                        onChange={onChangeInSelect}
                    >
                        {[10, 20, 30, 40, 50, 0].map(size => (
                            <option key={size} value={size}>
                                {size === 0 ? "All" : size}
                            </option>
                        ))}
                    </select>
                </Col>
            )}

            {(data || []).length > 0 && (
                // <div className="pagination justify-content-end align-items-center">
                <div className="paginations d-flex justify-content-end align-items-center">
                    <Container>
                        <Row className=" align-items-center">
                            <Col className="col-md-auto">
                                <div className="d-flex gap-1">
                                    <Button
                                        color="primary"
                                        onClick={handlestartpage}
                                        disabled={((pageNumber +1) <= 1) || pageSize === 0}
                                    >
                                        {"<<"}
                                    </Button>{" "}
                                    <Button
                                        color="primary"
                                        onClick={handleprev}
                                        disabled={((pageNumber +1) <= 1) || pageSize === 0}
                                    >
                                        {"<"}
                                    </Button>{" "}
                                </div>
                            </Col>
                            <Col className="col-md-auto d-none d-md-block">
                                <span>
                                    Page{" "}
                                    <strong>
                                        {pageNumber < 1 ? 1 : pageNumber +1} of {pageSize === 0 ? 1 : Math.ceil(totalCount / pageSize)}
                                    </strong>{" "}
                                </span>
                            </Col>
                            <Col className="col-md-auto">
                                <span>
                                    | Go to page:{" "}
                                    <input
                                        type="number"
                                        value={isSorting ? 1 : (inputPageNumber + 1)}
                                        onChange={onChangeInInput}
                                        disabled={pageSize === 0}
                                        style={{ width: "50px", textAlign: "center" }}
                                    />
                                </span>
                            </Col>
                            <Col className="col-md-auto">
                                <div className="d-flex gap-1">
                                    <Button
                                        color="primary"
                                        onClick={handlenext}
                                        disabled={
                                            pageNumber >= Math.ceil(totalCount / pageSize) -1
                                            || pageSize === 0
                                        }
                                    >
                                        {">"}
                                    </Button>{" "}
                                    <Button
                                        color="primary"
                                        onClick={handlelastpage}
                                        disabled={
                                            pageNumber >= Math.ceil(totalCount / pageSize) -1
                                            || pageSize === 0
                                        }
                                    >
                                        {">>"}
                                    </Button>{" "}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            )}
        </div>
    );
};

export default TablePagination;